import React from 'react';
import CloseIcon from './CloseIcon';

interface Props {
  bannerVisible?: boolean;
  index: number;
  imageLength: number;
  toolbarRender: any;
  toolbarLeftRender?: any;
  toolbarRightRender?: any;
  toolbarBottomRender?: any;
  overlayParams: any;
}

export default function CustomToolbars({
  bannerVisible,
  index,
  imageLength,
  toolbarRender,
  overlayParams,
  toolbarLeftRender,
  toolbarRightRender,
}: Props) {
  return (
    <>
      {bannerVisible && (
        <div className="PhotoView-Slider__BannerWrap">
          <div className="PhotoView-Slider__Counter">
            {index + 1} / {imageLength}
          </div>
          <div className="PhotoView-Slider__BannerRight">
            {toolbarRender && overlayParams && toolbarRender(overlayParams)}
            <CloseIcon className="PhotoView-Slider__toolbarIcon" onClick={close} />
          </div>
        </div>
      )}

      {toolbarLeftRender && overlayParams && (
        <div className="PhotoView-Slider__Toolbar PhotoView-Slider__Toolbar--Left">
          {toolbarLeftRender(overlayParams)}
        </div>
      )}

      {toolbarRightRender && overlayParams && (
        <div className="PhotoView-Slider__Toolbar PhotoView-Slider__Toolbar--Right">
          {toolbarRightRender(overlayParams)}
        </div>
      )}
    </>
  );
}
